import { _sportsInfoTypes, useSportsInfo } from "projectSpecific/sports/useHelpers/useSportsInfo";
import React, { useContext, useEffect, useMemo, useReducer, useRef, useState } from "react";
import { ParentContext } from '../../../../global/cnr/contexts/ParentContext';
import { _cacheNames, _cacheTypes } from "../../../../global/cnr/reducers/ServiceWorkerReducer";
import { sportsOrganizationHandlers, sportsOrganizationInitialState, sportsOrganizationReducer } from "../reducers/SportsOrganizationReducer";
import { _showAppLogs } from "global/cnr/contexts/LogContext";
import { useNavigationTransition } from "global/cnr/contexts/NavigationTransitionContext";
import { useCurrentLocation } from "global/cnr/contexts/useHelpers/useCurrentLocation";

export const SportsOrganizationContext = React.createContext()

export default function SportsOrganizationProvider(props) {

  const { directReturn } = props ?? {}

  const parentContext = useContext(ParentContext)
  const { states } = parentContext ?? {}
  const { paps_state, page_state, currentSettings_state, serviceWorker_state } = states ?? {}

  // papsContext 
  const { pathViews } = paps_state ?? {}
  const { organizations: organizations_key } = pathViews ?? {}
  const view = 'organizations'

  // pageContext 
  const { aps_global } = _.get(currentSettings_state, 'gvviSettings', {});
  const { aps_page } = _.get(page_state, 'pageSettings', {});
  const { projectOptions } = aps_global ?? {}
  let { useAppDarkMode } = projectOptions ?? {}

  const { viewItems: viewItems_page } = aps_page ?? {}

  let viewItem = viewItems_page && viewItems_page[view] ? viewItems_page[view] : {}
  const { dataSource } = viewItem ?? {}
  let { dataParents, useSeasonals } = dataSource ?? {}

  if (!dataParents) {
    dataParents = ['orgnaizations', 'districts']
  }

  const init_state = {
    useAppDarkMode,
    useSeasonals,
    _dataChecked: false,
  }

  // const { isNewPage } = useCurrentLocation({pathViews})

  // if (newPages.includes('organizations')) {
  //   console.log('newPages', newPages)
  //   // sports changed
  // }

  // const _previousPage = useRef(organizations_key)

  // const { startTransition } = useNavigationTransition()

  // const previousPathViews = useRef({
  //   organizations: pathViews.organizations,
  //   districts: pathViews.districts,
  //   sports: pathViews.sports
  // })

  // const newContext = {
  //   organizations:
  //     previousPathViews.current.organizations !== pathViews.organizations,

  //   district:
  //     previousPathViews.current.districts !== pathViews.districts,

  //   sport:
  //     previousPathViews.current.sports !== pathViews.sports
  // }

  // useEffect(() => {
  //   previousPathViews.current = {
  //     organizations: pathViews.organizations,
  //     districts: pathViews.districts,
  //     sports: pathViews.sports
  //   }
  // }, [
  //   pathViews.organizations,
  //   pathViews.districts,
  //   pathViews.sports
  // ])


  // useEffect(() => {
  //   if (!organizations_key) return;
  //   if (
  //     _previousPage.current &&
  //     _previousPage.current !== organizations_key
  //   ) {
  //     startTransition({
  //       type: 'organization',
  //       title: organizations_key
  //     })
  //   }
  //   _previousPage.current = organizations_key
  // }, [organizations_key, startTransition])

  const [sportsOrganization_state, sportsOrganization_dispatch] = useReducer(sportsOrganizationReducer, init_state, sportsOrganizationInitialState)
  const sportsOrganization_handlers = useMemo(
    () => sportsOrganizationHandlers(sportsOrganization_dispatch),
    [sportsOrganization_dispatch]
  );
  const { organization_data } = sportsOrganization_state ?? {}

  const [organizationInfo, setOrganizationInfo] = useState()
  const _loading = useRef(null);

  const { getSportInfoData } = useSportsInfo({ pathViews, sportsInfoType: _sportsInfoTypes.organizations, existingData: organization_data })

  useEffect(() => {
    // only fetch data if pathViews.organizations exists 
    if (!organizations_key) return;
    _showAppLogs.sportsOrganizations && console.log('⭐ new organization', organizations_key)
    // if (!organizations_key || (_loading.current === organizations_key)) return;
    _loading.current = organizations_key;
    getSportInfoData(_sportsInfoTypes.organizations, organizations_key, setOrganizationInfo)
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [organizations_key])

  useEffect(() => {
    if (_.isEmpty(organizationInfo) || !organizations_key) return;
    _showAppLogs.sportsDistricts && console.log('🟩 ⭐ organizationInfo', organizations_key, organizations_key)
    sportsOrganization_handlers.handleSet_organizationInfo(organizationInfo)
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [organizationInfo])

  if (sportsOrganization_state) {
    return <SportsOrganizationContext.Provider
      value={{ sportsOrganization_state, sportsOrganization_handlers, appComponent: 'sportsOrganization' }}>
      {props.children}
    </SportsOrganizationContext.Provider>
  } else {
    return <SportsOrganizationContext.Provider
      value={{}}>
      {props.children}
    </SportsOrganizationContext.Provider>
  }
}